// @flow

import { type IncomingPayment } from './types';

export function getRedirectBackUrl(incomingPayment: IncomingPayment): ?string {
  if(incomingPayment.status !== 'OP')
    return null;

  return incomingPayment['redirect_back_url'];
}
